import moment from 'moment';
import { globalFormat } from '../../../../utils/formatting';
import { GraphQLDate } from '../../../../utils/types';

export default (start: GraphQLDate, end: GraphQLDate) => {
  const { dateFormat } = globalFormat.getGlobalFormat();
  const startDate = globalFormat.formatDate(start, `ddd, ${dateFormat}`);

  if (!end || moment(start).isSame(end, 'day')) {
    return startDate;
  }

  return `${startDate} - ${globalFormat.formatDate(end, { dateFormat })}`;
};
